"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZoomMinMaxY = exports.showLineChartTooltipComponents = exports.hideLineChartTooltipComponents = exports.moveTooltipCircles = exports.formatTooltipXAxisValue = exports.formatIndicatorValue = exports.getSecondaryXAxisTickFormat = exports.getXAxisTickFormat = exports.yAxisTickFormat = void 0;
var tslib_1 = require("tslib");
var d3 = tslib_1.__importStar(require("d3"));
var pipe_1 = tslib_1.__importDefault(require("lodash/fp/pipe"));
var get_1 = tslib_1.__importDefault(require("lodash/fp/get"));
var flatMap_1 = tslib_1.__importDefault(require("lodash/fp/flatMap"));
var filter_1 = tslib_1.__importDefault(require("lodash/fp/filter"));
var chartUtils_1 = require("../chartUtils");
exports.yAxisTickFormat = function (d, precision) {
    return chartUtils_1.formatLinearNumbers(d, precision);
};
exports.getXAxisTickFormat = function (axisType, width, chartBreakPoints, ticks, precision) {
    switch (axisType) {
        case 'MONTH':
            if (width <= chartBreakPoints.medium[0] &&
                width > chartBreakPoints.small[0] &&
                ticks.length > 2) {
                return function (d, i) {
                    return i % 2 === 0 ? chartUtils_1.formatMonths(d, i, ticks, 2) : '';
                };
            }
            return function (d, i) { return chartUtils_1.formatMonths(d, i, ticks, 1); };
        default:
            if (width <= chartBreakPoints.medium[0] &&
                width > chartBreakPoints.small[0] &&
                ticks.length > 2) {
                return function (d, i) {
                    return i % 2 === 0 ? chartUtils_1.formatLinearNumbers(d, precision) : '';
                };
            }
            return function (d) { return chartUtils_1.formatLinearNumbers(d, precision); };
    }
};
exports.getSecondaryXAxisTickFormat = function (axisType, width, chartBreakPoints, ticks) {
    switch (axisType) {
        case 'MONTH':
            if (width <= chartBreakPoints.medium[0] &&
                width > chartBreakPoints.small[0] &&
                ticks.length > 2) {
                return function (d, i) {
                    return i % 2 === 0 ? chartUtils_1.formatYears(d, i, ticks, 2) : '';
                };
            }
            return function (d, i) { return chartUtils_1.formatYears(d, i, ticks, 1); };
        default:
            return undefined;
    }
};
exports.formatIndicatorValue = function (value, precision) {
    if (precision === void 0) { precision = 2; }
    return chartUtils_1.formatLinearNumbers(value, precision);
};
exports.formatTooltipXAxisValue = function (axisType, value) {
    switch (axisType) {
        case 'MONTH':
            return d3.timeFormat('%b %Y')(value);
        default:
            return chartUtils_1.formatLinearNumbers(value);
    }
};
exports.moveTooltipCircles = function (_a) {
    var tooltipCircles = _a.tooltipCircles, tooltipData = _a.tooltipData, xScale = _a.xScale, yScale = _a.yScale;
    d3.select(tooltipCircles)
        .selectAll('.tooltip-circle')
        .data(tooltipData)
        .attr('opacity', function (d) {
        return d.value ? 1 : 0;
    })
        .attr('transform', function (d) {
        return d.value
            ? "translate(" + xScale(d.value.x) + ", " + yScale(d.value.y) + ")"
            : 'translate(0, 0)';
    });
};
exports.hideLineChartTooltipComponents = function (_a) {
    var tooltipCircles = _a.tooltipCircles, useTransition = _a.useTransition;
    if (useTransition) {
        d3.select(tooltipCircles)
            .selectAll('.tooltip-circle')
            .transition()
            .attr('opacity', 0);
    }
    else {
        d3.select(tooltipCircles).selectAll('.tooltip-circle').attr('opacity', 0);
    }
};
exports.showLineChartTooltipComponents = function (_a) {
    var tooltipCircles = _a.tooltipCircles;
    d3.select(tooltipCircles)
        .selectAll('.tooltip-circle')
        .transition()
        .attr('opacity', 1);
};
exports.getZoomMinMaxY = function (xScale, data) {
    var _a = xScale.domain(), lowerBound = _a[0], upperBound = _a[1];
    var minXInZoom = xScale(lowerBound);
    var maxXInZoom = xScale(upperBound);
    var dataInZoom = pipe_1.default(flatMap_1.default(get_1.default('values')), filter_1.default(function (v) { return xScale(v.x) >= minXInZoom && xScale(v.x) <= maxXInZoom; }))(data);
    var minY = d3.min(dataInZoom, function (d) { return d.y; });
    var maxY = d3.max(dataInZoom, function (d) { return d.y; });
    return {
        minY: minY,
        maxY: maxY,
    };
};
